---
headline: Terms of use.
---

## The short version

This is a marketing site for Brian Ellison Design, an independent interior design studio in Melbourne, Florida. The content here describes our practice and our work. By visiting the site, you agree to the terms below.

## Ownership

All site content — text, images, design, code — is © Brian Ellison Designs LLC. You may share and link freely. You may not reproduce substantial portions without permission.

## Project images

Photography, drawings, and visualizations of projects are shown with permission of the project owners where applicable. If you see an image that you believe was used without permission, please write us at <a href="mailto:brianellisondesigns@icloud.com" class="text-link">brianellisondesigns@icloud.com</a>.

## Inquiry submissions

If you submit a project inquiry through this site, you are not entering a contract for services. We will respond, but a formal engagement begins only with a signed agreement.

## Liability

This site is provided "as is." It uses progressive-enhancement WebGL on the home page; if your device doesn't support it, the page falls back to a static version. We make no guarantees about availability.

## Governing law

Florida, USA.

These terms were last updated **2026-05-20**.
